// extracted by mini-css-extract-plugin
export default {"select":"FormItems_select__J6ClV","formItem":"FormItems_formItem__s1OF-"};